import css from '@emotion/css/macro'
import appColors from '@sportninja/common/constants/appColors'
import { font, weightSemiBold } from 'src/components/css'

const colors = appColors as Record<string, string>

export const cardContainerStyles = (isLive: boolean) => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${colors.SECONDARY_400};
  border: 1px solid ${isLive ? colors.PRIMARY : colors.SECONDARY_200};
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.2s ease-in-out, filter 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    filter: brightness(1.05);
  }
`

export const headerBarStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 16px;
  background-image: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0) 44.712%,
      ${colors.SECONDARY_500} 100%
    ),
    linear-gradient(
      90deg,
      ${colors.SECONDARY_350} 0%,
      ${colors.SECONDARY_350} 100%
    );
`

/* The game type badge. Geometry, type scale and letter-spacing are copied
   EXACTLY from the event row's category badge (EventListRow's
   categoryTagStyles) — a game and an event sitting in one list must label
   their kind identically, so the two blocks are meant to stay in lockstep.
   The fill and text colour come from getGameTypeBadge, per game type. */
export const gameTypeTagStyles = css`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  padding: 3px 10px;
  border-radius: 4px;
  ${font.body}
  ${weightSemiBold}
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 1.44px;
  text-transform: uppercase;
  white-space: nowrap;
`

export const contentRowStyles = css`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 8px 16px;
`

const captionUppercaseBase = css`
  font-family: 'Inter', Arial, Helvetica, sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 14.4px;
  letter-spacing: 1.44px;
  text-transform: uppercase;
`

export const badgeBaseStyles = css`
  ${captionUppercaseBase}
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 2px 4px;
  border-radius: 4px;
  white-space: nowrap;
`

export const liveBadgeStyles = css`
  ${badgeBaseStyles}
  background-color: ${colors.RED};
  color: ${colors.WHITE};
`

export const nextBadgeStyles = css`
  ${badgeBaseStyles}
  background-color: ${colors.NEXT_BADGE};
  color: ${colors.WHITE};
  line-height: 'auto';
`

export const watchBadgeStyles = css`
  ${badgeBaseStyles}
  background-color: ${colors.INFO_300};
  color: ${colors.WHITE};
`

export const roleLabelStyles = css`
  ${captionUppercaseBase}
  color: ${colors.WHITE};
  white-space: nowrap;
`

export const scoreStyles = css`
  width: 65px;
  text-align: center;
  flex-shrink: 0;
`

export const winnerBarStyles = css`
  height: 4px;
  background-color: ${colors.DEFAULT_FLAIR};
  margin-top: 2px;
  border-radius: 2px;
`

export const teamContainerStyles = (isHome: boolean) => css`
  display: flex;
  flex: 1;
  align-items: center;
  gap: 8px;
  min-width: 0;
  ${!isHome && 'flex-direction: row-reverse;'}
`

export const teamTextContainerStyles = (isHome: boolean) => css`
  display: flex;
  flex-direction: column;
  ${!isHome && 'align-items: flex-end; text-align: right;'}
`

export const centerInfoStyles = css`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-width: 0;
`

export const venueRowStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`

export const captionSmallLabelStyles = css`
  ${captionUppercaseBase}
  color: ${colors.NEUTRAL_50};
`
